import _ from 'lodash';
import { formatDecimal } from 'Common/FormHelper';
import { MealEquivalentSetupEnum as Fields } from 'Common/FieldEnum';
import { getFiscalYear } from 'Common/GeneralHelper';
import * as types from './types';

const INITIAL_STATE = {
  gridData: [],
  loading: false,
  saveSuccessful: false,
  selectedFiscalYear: getFiscalYear(new Date()),
  fiscalYears: [],
  isAllChecked: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.MEAL_EQUIVALENT_LOADING:
      return { ...state, loading: payload };

    case types.MEAL_EQUIVALENT_GET_FISCAL_YEARS:
      return { ...state, fiscalYears: payload.data };

    case types.MEAL_EQUIVALENT_SET_ERROR:
      return { ...state, error: payload };

    case types.MEAL_EQUIVALENT_GRID_CHECK_ALL: {
      const stateCopy = _.cloneDeep(state);
      const newGridData = stateCopy.gridData.map(item => {
        return { ...item, Selected: payload };
      });

      return {
        ...state,
        gridData: newGridData,
        isAllChecked: payload,
      };
    }

    case types.MEAL_EQUIVALENT_GET_GRID_DATA: {
      const gridData = payload.response.data.Data.map(item => {
        return {
          ...item,
          Selected: false,
          [Fields.BreakfastToLunch]: formatDecimal(2)(
            item[Fields.BreakfastToLunch]
          ),
          [Fields.SnackToLunch]: formatDecimal(2)(item[Fields.SnackToLunch]),
          [Fields.SupplementalToLunch]: formatDecimal(2)(
            item[Fields.SupplementalToLunch]
          ),
        };
      });

      return {
        ...state,
        gridData,
        selectedFiscalYear: payload.fiscalYear,
      };
    }

    case types.MEAL_EQUIVALENT_CLEAR_ERROR:
      return { ...state, error: null };

    case types.MEAL_EQUIVALENT_SET_SUCCESSFUL:
      return { ...state, saveSuccessful: payload };

    case types.MEAL_EQUIVALENT_GRID_CHECK_ITEM: {
      const stateCopy = _.cloneDeep(state);
      const { gridData } = stateCopy;
      const foundRow = gridData.find(row => row.SiteId === payload.row.SiteId);
      const index = gridData.indexOf(foundRow);

      gridData[index].Selected = payload.shouldCheck;
      const allSelected = gridData.every(row => row.Selected);
      return {
        ...state,
        gridData,
        isAllChecked: allSelected,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/mealequivalentsetup/state/siteequivalent/reducer.js